import { IGetFreeStepPosService } from '../ports/get-free-step-pos.port'
import { useGetFreeStepPos } from '../infrastructure/script/get-free-pos/get-free-pos'

export const useGetFreeStepPosAdapter = (): IGetFreeStepPosService => {
	return useGetFreeStepPos()
}
